import { render, staticRenderFns } from "./IzvestajGost.vue?vue&type=template&id=3178fe80&scoped=true&"
import script from "./IzvestajGost.vue?vue&type=script&lang=js&"
export * from "./IzvestajGost.vue?vue&type=script&lang=js&"
import style1 from "./IzvestajGost.vue?vue&type=style&index=1&id=3178fe80&prod&scoped=true&lang=css&"
import style2 from "./IzvestajGost.vue?vue&type=style&index=2&id=3178fe80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178fe80",
  null
  
)

export default component.exports